<template>
  <v-snackbar
    :model-value="snackbar.model"
    class="snackbar"
    :color="snackbar.type"
    :timeout="snackbar.timeout"
    location="bottom end"
    @update:model-value="onClose"
  >
    <span v-text="snackbar.msg" />
    <template #actions>
      <v-btn
        v-if="snackbar.close"
        variant="text"
        @click="onClose"
      >
        CLOSE
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

import { useNotificationStore } from '@/stores/notification'

export default defineComponent({
  name: 'Snackbar',

  setup () {
    const notificationStore = useNotificationStore()
    const snackbar = computed(() => notificationStore.snackbarProps)

    function onClose (): void {
      notificationStore.closeSnackbar()
    }

    return {
      snackbar,
      onClose,
    }
  },
})
</script>

<style lang="sass" scoped>
.snackbar
  padding-right: 22px
</style>
